import breakpoints from '@fronton/postcss-plugin/src/presets/lmru-grid';
import { useWindowSize } from './use-window-size';

export const useBreakpoints = () => {
  const { width } = useWindowSize();

  const {
    mobile: { breakpoint: mobile },
    tablet: { breakpoint: tablet },
    desktop: { breakpoint: desktop },
    largeDesktop: { breakpoint: largeDesktop },
  } = breakpoints;

  return {
    atMobile: !!mobile.max && width <= mobile.max,
    toTablet: !!tablet.max && width <= tablet.max,
    atTablet: !!tablet.min && !!tablet.max && tablet.min <= width && width <= tablet.max,
    fromTablet: !!tablet.min && tablet.min <= width,
    toDesktop: !!desktop.max && width <= desktop.max,
    atDesktop: !!desktop.min && !!desktop.max && desktop.min <= width && width <= desktop.max,
    fromDesktop: !!desktop.min && desktop.min <= width,
    fromLargeDesktop: !!largeDesktop.min && largeDesktop.min <= width,
  };
};
